import type { Coord } from "@dailywars/core/engine";
import type { RefObject } from "react";

import type { ScrollChromeRefs } from "#/components/game/gameCanvas/boardViewport";

import { PlayMapGameCard } from "./gameCard";

type PlayMapPageShellProps = {
  handleEndTurn: () => void | Promise<void>;
  handleRestart: () => void | Promise<void>;
  isRestarting: boolean;
  boardScrollFocus: Coord | null;
  topDockRef: RefObject<HTMLDivElement | null>;
  bottomDockRef: RefObject<HTMLDivElement | null>;
  scrollChrome: ScrollChromeRefs;
};

export function PlayMapPageShell({
  handleEndTurn,
  handleRestart,
  isRestarting,
  boardScrollFocus,
  topDockRef,
  bottomDockRef,
  scrollChrome,
}: PlayMapPageShellProps) {
  return (
    <main className="flex w-full min-w-0 grow flex-col items-center">
      <PlayMapGameCard
        boardScrollFocus={boardScrollFocus}
        topDockRef={topDockRef}
        bottomDockRef={bottomDockRef}
        scrollChrome={scrollChrome}
        handleEndTurn={handleEndTurn}
        handleRestart={handleRestart}
        isRestarting={isRestarting}
      />
    </main>
  );
}
